import { render, staticRenderFns } from "./GroupDiscountBus.vue?vue&type=template&id=08b37508"
import script from "./GroupDiscountBus.vue?vue&type=script&lang=js"
export * from "./GroupDiscountBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports